// @ts-nocheck

import { type StateType } from '../../../../states';
import { type Selector } from '../../../../types/selectors';
import { type BoomMiscState } from '../../reducers/boom';
import { type BoomNotificationState } from '../../types/notification';
import { selectBoomState } from '../boom/boomPrimary.selector';

const emptyObj = {};
const emptyArray: [] = [];

export const selectBoomMiscState: Selector<BoomMiscState> = (state: StateType) =>
  selectBoomState(state)?.misc ?? emptyObj;

export const selectBoomMiscTmpNotifications: Selector<Array<BoomNotificationState>> = (state: StateType) =>
  selectBoomMiscState(state).tmpNotifications ?? emptyArray;
